<template>
		<div class="course-detail">
			<!-- 浏览器限制遮罩 -->
			<div v-if="showBrowserBlock" class="browser-block-overlay">
				<div class="browser-block-content">
					<div class="browser-block-icon">⚠️</div>
					<h3>浏览器不支持</h3>
					<p>为了保护视频内容安全，本页面不支持UC浏览器和夸克浏览器访问。</p>
					<p>请使用Chrome、Safari、Firefox或Edge等浏览器访问。</p>
					<button class="browser-block-btn" @click="goBack">返回</button>
				</div>
			</div>
			<div class="cont">
				<div class="main">
					<div class="back" @click="goBack">< 返回</div>
					<div :class="isScreen?'iframeContAct':'iframeCont'" v-if="courseDetailList[act]&&courseDetailList[act].qf_url">
						<div class="screen" @click="isScreen=!isScreen">{{isScreen?'窗口':'全屏'}}</div>
					  <iframe allow="camera; microphone; geolocation; fullscreen; clipboard-read; clipboard-write; accelerometer; gyroscope; payment; display-capture; autoplay" :src="courseDetailList[act]&&courseDetailList[act].qf_url+'&user_id='+userInfo.qfUserId+'&token='+userInfo.qfToken" style="border: none;"></iframe>
					</div>
					<div v-else id="mse"></div>
					<!-- <video id="myVideo" v-else :src="courseDetailList[act]&&courseDetailList[act].video_url" controls controlsList="nodownload noremoteplayback" @contextmenu.prevent @dragstart.prevent @selectstart.prevent></video> -->
					<div class="text-cont">
						<div class="title">
							<div>{{courseDetailList[act]&&courseDetailList[act].name}}</div>
							<div class="ruo">{{courseDetailList[act]&&courseDetailList[act].point_name}}</div>
						</div>
						<div class="details">
							<!-- <div>{{this.userInfo.gradeClass.split("/")[0]}} - {{courseDetailList[act]&&courseDetailList[act].subject}}</div> -->
							<div>老师：{{courseDetailList[act]&&courseDetailList[act].teacher}}</div>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="sub-head">
						<div class="course-title">课程列表</div>
						<div class="goTest" @click="goTest">做练习</div>
					</div>	
					<div class="course-cont">
						<div class="course-card" @click="checkTi(index)" v-for="(item,index) in courseDetailList" :key="index">
							<div class="course-bg" :style="{backgroundImage:`url(${item.coverImg})`}">
								<div v-if="item.isCompleted" class="course-study">已完成</div>
							</div>
							<div class="course-name">{{item.name}}</div>
							<div class="course-text">{{item.point_info}}</div>
							<div class="course-btn">
								<!-- <img class="course-avator" :src="$route.query.avator" alt="" /> -->
								<span class="course-teacher">{{item.teacher}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>
<script>
import Player from 'xgplayer';
import 'xgplayer/dist/index.min.css';
export default {
	name: 'index',

	components: {},

	data(){
		return {
			userInfo:JSON.parse(localStorage.getItem('userInfo')),
			courseDetailList:[],
			act:0,
			showIframe: false,
			isScreen:false,
			startTime: null, // 开始时间
			player: null, // xgplayer实例
			showBrowserBlock: false // 浏览器限制遮罩显示状态
		}
	},

	created(){
		// 检测浏览器类型
		if (this.checkRestrictedBrowser()) {
			this.showBrowserBlock = true;
			return; // 如果是受限浏览器，不执行后续逻辑
		}
		this.query = this.$route.query
		this.getRecordList();
	},
	beforeDestroy() {
		this.getRecordAdd(false);//退出页面时上传学习记录
		
		// 销毁播放器实例
		if (this.player) {
			this.player.destroy();
			this.player = null;
		}
	},
	mounted() {
			// 记录进入页面的时间
			this.startTime = new Date();
			
			// 原myVideo相关逻辑（已替换为xgplayer）
			/*
			var video = document.getElementById('myVideo');
			if (video) {
				video.play().catch(error => {
					console.error("自动播放失败:", error);
				});
				// 禁用右键菜单
				video.addEventListener('contextmenu', function(e) {
					e.preventDefault();
					return false;
				});
				// 禁用拖拽
				video.addEventListener('dragstart', function(e) {
					e.preventDefault();
					return false;
				});
				// 禁用选择
				video.addEventListener('selectstart', function(e) {
					e.preventDefault();
					return false;
				});
				// 禁用键盘快捷键下载
				video.addEventListener('keydown', function(e) {
					// 禁用Ctrl+S, Ctrl+A, F12等快捷键
					if (e.ctrlKey && (e.keyCode === 83 || e.keyCode === 65)) {
						e.preventDefault();
						return false;
					}
					if (e.keyCode === 123) { // F12
						e.preventDefault();
						return false;
					}
				});
				// 设置video属性
				video.setAttribute('disablePictureInPicture', 'true');
				video.setAttribute('disableRemotePlayback', 'true');
			}
			this.$nextTick(() => {
				const videoElement = this.$el.querySelector('video');
				if (videoElement) {
					videoElement.addEventListener('ended', this.getRecordAdd);
				}
			});
			*/
		},

	computed: {

	},
	watch: {

	},
	methods: {
		// 检测是否为受限浏览器（UC浏览器和夸克浏览器）
		checkRestrictedBrowser() {
			const userAgent = navigator.userAgent.toLowerCase();
			// 检测UC浏览器
			const isUC = userAgent.includes('ucbrowser') || userAgent.includes('uc browser') || userAgent.includes('ucweb') || userAgent.includes('ucpc');
			// 检测夸克浏览器
			const isQuark = userAgent.includes('quark') || userAgent.includes('quarkbrowser');
			
			console.log('User Agent:', userAgent);
			console.log('Is UC Browser:', isUC);
			console.log('Is Quark Browser:', isQuark);
			
			return isUC || isQuark;
		},
		
		goTest(item){
			this.$router.push({  //核心语句
			  path:'/testDetail',   //跳转的路径
			  query:{
					id:this.query.id,
					point_name:this.query.name,
					subject:localStorage.getItem('actTab'),
					point_info:item.name,
				}
			})
		},
		calculateTimeSpent() {
			// 计算停留时间（分钟）
			const timeSpent = (new Date() - this.startTime) / 1000;
			console.log(`本次学习时长：${parseInt(timeSpent)} 秒`);
			return parseInt(timeSpent)
		},
		checkTi(index){
			this.act = index;
			this.getRecordAdd(false);//切换课程时上传学习记录
			this.initPlayer(); // 重新初始化播放器
		},
		//获取学习记录（清大）
		async getRecordList(){
			let jsondata = {
				pointId:this.$route.query.id,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:1,//课程
			};
			// 判断是否从弱点清单的ruo-btn按钮点击过来
			const fromRuo = this.$route.query.fromRuo === 'true' || this.$route.query.fromRuo === true;
			let res;
			if (fromRuo) {
				// 从ruo-btn点击过来，使用getWeekRecordList接口
				res = await this.$api.getWeekRecordList(jsondata);
			} else {
				// 从course-card点击过来，使用原来的getRecordList接口
				res = await this.$api.getRecordList(jsondata);
			}
			if (res.data.success) {
				this.businessIds = res.data.data.businessIds;
				this.getCourseDetailList();
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		
		//上传学习记录（清大）
		async getRecordAdd(status){
			let jsondata = {
				pointId:this.query.id,
				pointName:this.query.name,
				subject:this.query.subject,//学科
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:1,//课程
				reqVo: {
					businessId: this.courseDetailList[this.act].id+'',
					businessName: this.courseDetailList[this.act].name,
					type: 1,
					completeStatus:status.type?true:false,
					operaLongTime: ""+this.calculateTimeSpent()
				}
			};
			const res = await this.$api.getRecordAdd(jsondata);
			if (res.data.success) {
				if(status.type){
					localStorage.setItem('courseHot',true);
					this.courseDetailList[this.act].isCompleted = true;
				}
				this.$forceUpdate();
				let allCompleted = true;
				this.courseDetailList.forEach((courseItem, index) => {
				  if (!courseItem.isCompleted) {
				    allCompleted = false;
				  }
				});
				
				// 如果所有其他子项的 isCompleted 都为 true，则调用 complete() 方法
				if (allCompleted) {
				  this.getLearnComplete();
				}
				this.startTime = new Date();
				console.dir('上传学习记录完成')
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		//学习知识点完结操作
		async getLearnComplete(){
			let jsondata = {
				pointId:this.query.id,
				subject:this.query.subject,//学科
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:1,//课程
			};
			const res = await this.$api.getLearnComplete(jsondata);
			if (res.data.success) {
				localStorage.setItem('courseHot',true);
				this.$message.success('该知识点课程已全部完成');
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		//获取qf小课
		async getCourseDetailList() {
			console.dir(this.userInfo);
			let grades;
			if(localStorage.getItem("schoolType")){
				grades = localStorage.getItem("schoolType") === "C" ? '初中' : '高中';
			}
			let jsondata = {
				point_id:this.$route.query.id,
				phone:this.userInfo.accountCode,//手机号
				subject:this.$route.query.subject,//学科
				city:this.userInfo.cityId,//城市
				school:this.userInfo.schoolId,//学校
				level:grades||this.userInfo.gradeClass.split("/")[0],//年级
				pid:"w7398uoaiIAF98wu",//pid
				user_id:JSON.parse(localStorage.getItem('userInfo')).qfUserId,
				status:[],
			};
			const res = await this.$api.getCourseDetailList(jsondata);
			if (res.data.code === 0) {
				this.courseDetailList = res.data.data;
				if (this.businessIds && this.businessIds.length > 0) {
				    this.courseDetailList.forEach(course => {
				        if (this.businessIds.includes(course.id.toString())) {
				            course.isCompleted = true;  // 设置已完成状态
				        }
				    });
				}
				console.log('courseDetailList',this.courseDetailList)
				this.initPlayer();
				// 原myVideo播放器初始化代码（已替换为xgplayer）
				/*
				let player = new Player({
					id: 'mse',
					url: this.courseDetailList[this.act].video_url
				});
				*/
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		// 初始化播放器
		initPlayer() {
			// 销毁之前的播放器实例
			if (this.player) {
				this.player.destroy();
				this.player = null;
			}
			
			// 创建新的播放器实例
			this.player = new Player({
				id: 'mse',
				url: this.courseDetailList[this.act].video_url,
				autoplay: true,
				pip: false, // 禁用画中画
				download: false, // 禁用下载
				playbackRate: [0.5, 0.75, 1, 1.25, 1.5, 2], // 播放速度选项
				controls: {
					mode: 'normal'
				}
			});
			
			// 添加事件监听
			this.player.on('ready', () => {
				// 播放器准备就绪
				const video = this.player.video;
				if (video) {
					// 禁用右键菜单
					video.addEventListener('contextmenu', function(e) {
						e.preventDefault();
						return false;
					});
					// 禁用拖拽
					video.addEventListener('dragstart', function(e) {
						e.preventDefault();
						return false;
					});
					// 禁用选择
					video.addEventListener('selectstart', function(e) {
						e.preventDefault();
						return false;
					});
					// 禁用键盘快捷键下载
					video.addEventListener('keydown', function(e) {
						// 禁用Ctrl+S, Ctrl+A, F12等快捷键
						if (e.ctrlKey && (e.keyCode === 83 || e.keyCode === 65)) {
							e.preventDefault();
							return false;
						}
						if (e.keyCode === 123) { // F12
							e.preventDefault();
							return false;
						}
					});
					// 设置video属性
					video.setAttribute('disablePictureInPicture', 'true');
					video.setAttribute('disableRemotePlayback', 'true');
					video.setAttribute('controlsList', 'nodownload noremoteplayback');
				}
			});
			
			// 添加视频结束事件监听
			this.player.on('ended', () => {
				this.getRecordAdd({type: true});
			});
			
			// 自动播放
			this.player.on('canplay', () => {
				this.player.play().catch(error => {
					console.error("自动播放失败:", error);
				});
			});
		},
		
		goBack(){
			// 在浏览器限制状态下，直接关闭当前页面或返回上一页
			if (this.showBrowserBlock) {
				// 尝试关闭当前窗口，如果无法关闭则返回上一页
				if (window.opener) {
					window.close();
				} else {
					window.history.back();
				}
			} else {
				this.$router.back();
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.course-detail{
	padding: 1.5rem;
	.cont{
		display: flex;
		.main{
			flex:1;
			margin-right: 1.5rem;
			.back{
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.5rem;
				line-height: 1.88rem;
				margin-bottom: 1.5rem;
			}
			video{
				width: 90%;
				/* 禁用右键菜单 */
				pointer-events: auto;
				-webkit-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
			}
			/* 隐藏video控件中的下载按钮 */
			video::-webkit-media-controls-download-button {
				display: none;
			}
			video::-webkit-media-controls-enclosure {
				overflow: hidden;
			}
			video::-webkit-media-controls-panel {
				width: calc(100% + 30px);
			}
			.iframeCont{
				iframe{
					width: 100%;
					height: 43rem;
				}
			}
			.iframeContAct{
				position: absolute;
				z-index: 99;
				width: 100vw;
				height: 100vh;
				top: 0;
				left: 0;
				background-color: #fff;
				iframe{
					width: 100vw;
					height: 100vh;
				}
			}
			.screen{
				text-align: center;
				width: 3rem;
				height: 3rem;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 100%;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1rem;
				line-height: 1.88rem;
				position: absolute;
				bottom: 4rem;
				left: 2rem;
				z-index: 999;
				color: #FFFFFF;
				background: rgb(100, 45, 113);
				border: 0.2rem solid #E0E0E0;
			}
			.text-cont{
				background-color: #FFF;
				padding: 1.2rem;
				margin-top: 0.2rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-radius: 0.2rem;
				width: 87%;
			}
			.title{
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.6rem;
				color: #000000;
				line-height: 1.7rem;
				display: flex;
				align-items: center;
				.ruo{
					background-color: rgb(100, 45, 113);
					border-radius: 0.25rem;
					padding: 0 1rem;
					color: #fff;
					margin-left: 1.5rem;
					font-size: 1rem;
					font-weight: 400;
				}
			}
			.details{
				display: flex;
				width: 18rem;
				font-size: 1.4rem;
				justify-content: space-between;
			}
		}
		// <div class="cont">
		// 	<div class="main">
		// 		<video src="" controls></video>
		// 		<div class="title">
		// 			<div>平抛运动详解</div>
		// 			<div class="ruo">绝对值</div>
		// 		</div>
		// 		<div class="details">
		// 			<div>初三 - 数学</div>
		// 			<div>老师：李老师</div>
		// 		</div>
		// 	</div>
		// 	<div class="right">
		.right{
			width: 19rem;
			.sub-head{
				margin-bottom: 1.25rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-left: 0.75rem;
				.course-title{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 500;
					font-size: 1.6rem;
					color: #000000;
					line-height: 1.7rem;
				}
				.course-more{
					display: flex;
					align-items: center;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 1.2rem;
					color: rgba(0,0,0,0.8);
					line-height: 1.41rem;
					img{
						width: 1.4rem;
						height: 1.4rem;
					}
				}
				.goTest{
					font-size: 1.1rem;
					color: #642d71;
					border: 1px solid #642d71;
					border-radius: 4px;
					padding: 1px 4px;
				}
			}
			.course-cont{
				// display: flex;
				// flex-direction: column;
				// justify-content: flex-start;
				height: 51rem;
				box-sizing: border-box;
				overflow-y: auto;
				overflow-x: hidden;
				.course-card{
					width: 18.35rem;
					height: 14.45rem;
					background: #FFFFFF;
					border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
					margin: 0.7rem;
					overflow: hidden;
					.course-bg{
						width: 18.35rem;
						height: 7.5rem;
						background-repeat: no-repeat;
						background-size: cover;
						position: relative;
						.course-study{
							position: absolute;
							top: 0.75rem;
							right: 0.75rem;
							width: 4.35rem;
							height: 1.8rem;
							border-radius: 3rem 3rem 3rem 3rem;
							font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
							font-size: 0.8rem;
							background: rgb(100, 45, 113);
							color:#fff;
							line-height: 1.8rem;
							text-align: center;
						}
						.course-ruo{
								position: absolute;
								right: 0;
								top: 0;
								width: 2.45rem;
								height: 2.05rem;
						}
					}
					.course-name{
						margin: 0.75rem 0.9rem 0.6rem;
						font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
						font-weight: 500;
						font-size: 1.2rem;
						color: #1D1D1D;
						line-height: 1.3rem;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						/*! autoprefixer: off */
						-webkit-box-orient: vertical;
					}
					.course-text{
						margin: 0 0.9rem 0.5rem;
						font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
						font-size: 0.8rem;
						color: #74798C;
						line-height: 1rem;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						/*! autoprefixer: off */
						-webkit-box-orient: vertical;
					}
					.course-btn{
						display: flex;
						align-items: center;
						justify-content: flex-start;
						margin: 0 0.9rem;
						.course-avator{
							width: 1.2rem;
							height: 1.2rem;
							border-radius: 6rem;
							margin-right: 0.4rem;
						}
						.course-teacher{
							font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
							font-size: 0.8rem;
							color: #1D1D1D;
							line-height: 1.12rem;
						}
						.course-save{
							background-image: url('../assets/heart-1.png');
							background-repeat: no-repeat;
							background-size: contain;
							width: 1.2rem;
							height: 1.2rem;
							margin-left: auto;
						}
					}
				}
			}
		}
	}
}
#mse {
	width: 90%!important;
	height: 78vh!important;
	border-radius: 8px!important;
}

/* 浏览器限制遮罩样式 */
.browser-block-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.8);
	z-index: 99999;
	display: flex;
	align-items: center;
	justify-content: center;
}

.browser-block-content {
	background: white;
	border-radius: 12px;
	padding: 40px;
	text-align: center;
	max-width: 500px;
	margin: 20px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.browser-block-icon {
	font-size: 48px;
	margin-bottom: 20px;
}

.browser-block-content h3 {
	color: #333;
	font-size: 24px;
	margin-bottom: 20px;
	font-weight: bold;
}

.browser-block-content p {
	color: #666;
	font-size: 16px;
	line-height: 1.6;
	margin-bottom: 15px;
}

.browser-block-btn {
	background: #1890ff;
	color: white;
	border: none;
	padding: 12px 30px;
	border-radius: 6px;
	cursor: pointer;
	font-size: 16px;
	margin-top: 20px;
	transition: all 0.3s;
}

.browser-block-btn:hover {
	background: #40a9ff;
	transform: translateY(-1px);
}
</style>
